export default "__VITE_ASSET__6fb14b42__"